import { c as _c } from "react/compiler-runtime";
import useChatMessageStore from '@module/stores/useChatMessageStore';
import useChatPanelStore from '@module/stores/useChatPanelStore';
import { useFetchLivePlayMutationStore } from '@module/stores/useFetchLivePlayMutationStore';
import { useEffect } from 'react';
import constructFreezeOnPayload from './constructFreezeOnPayload';

/**
 * 채팅방 진입/퇴장 라이프사이클 효과(브랜드 공통).
 * - hide 모드면 메시지 목록을 비운다.
 * - 진입 시 채팅 잠금(freeze) 상태이면 안내 메시지를 한 번 추가한다.
 * - 방 전환/언마운트 시 열려 있던 채팅 패널(설정/팬목록/이모티콘)을 닫는다.
 *
 */
function useChatRoomLifecycle() {
  const $ = _c(9);
  const {
    data: playInfo
  } = useFetchLivePlayMutationStore();
  const chatMessages = useChatMessageStore(_temp);
  const setChatMessages = useChatMessageStore(_temp2);
  const {
    setIsChattingSettingOpen,
    setIsFanListPopupOpen,
    setIsChatEmoticonSelectBoxOpen
  } = useChatPanelStore(_temp3);
  let t0;
  if ($[0] !== chatMessages || $[1] !== playInfo || $[2] !== setChatMessages || $[3] !== setIsChatEmoticonSelectBoxOpen || $[4] !== setIsChattingSettingOpen || $[5] !== setIsFanListPopupOpen) {
    t0 = () => {
      if (!playInfo) {
        return;
      }
      const isChatHideMode = playInfo.chatMode === "hide";
      if (isChatHideMode) {
        setChatMessages([]);
        return;
      }
      const isChatFrozen = playInfo.roomFreezeInfo?.enable;
      const isFirstEnter = chatMessages.length === 0;
      if (isFirstEnter && isChatFrozen) {
        setChatMessages(prev => [...prev, constructFreezeOnPayload({
          name: playInfo.roomFreezeInfo?.name || "",
          messageType: "past"
        })]);
      }
      return () => {
        setIsChattingSettingOpen(false);
        setIsFanListPopupOpen(false);
        setIsChatEmoticonSelectBoxOpen(false);
      };
    };
    $[0] = chatMessages;
    $[1] = playInfo;
    $[2] = setChatMessages;
    $[3] = setIsChatEmoticonSelectBoxOpen;
    $[4] = setIsChattingSettingOpen;
    $[5] = setIsFanListPopupOpen;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[7] !== playInfo) {
    t1 = [playInfo];
    $[7] = playInfo;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  useEffect(t0, t1);
}
function _temp3(state_1) {
  return {
    setIsChattingSettingOpen: state_1.setIsChattingSettingOpen,
    setIsFanListPopupOpen: state_1.setIsFanListPopupOpen,
    setIsChatEmoticonSelectBoxOpen: state_1.setIsChatEmoticonSelectBoxOpen
  };
}
function _temp2(state_0) {
  return state_0.setChatMessages;
}
function _temp(state) {
  return state.chatMessages;
}
export default useChatRoomLifecycle;